import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import qs from 'qs';
import Axios from 'axios';
import axios from "./axios";
import { uploadToS3 } from "./files";
export const getImports = () => axios.get('/imports/v1');
export const getTables = () => axios.get('/imports/v1/tables');
export const getImport = id => axios.get(`/imports/v1/${id}`);
export const deleteImports = id => axios.delete(`/imports/v1/${id}`);
export const downloadTemplate = (entity, fields) => axios.get(`/imports/v1/template/${entity}`, {
  params: {
    'fields[]': fields
  },
  paramsSerializer: {
    serialize: p => qs.stringify(p, {
      arrayFormat: 'comma',
      encode: false
    })
  }
});
export const getUploadDescriptor = data => axios.post('/imports/v1/uploadFile', data);
export const updateUploadDescriptor = (id, data) => axios.put(`/imports/v1/uploadFile/${id}`, data);
export const createImport = data => axios.post('/imports/v1', data);
export const updateImport = (id, data) => axios.put(`/imports/v1/${id}`, data);
export const getImportSchema = id => {
  return axios.get(`/imports/v1/${id}/schema`, {}).then(result => {
    if (result.data.url) return Axios.get(result.data.url);
    throw new Error('No schema url provided');
  });
};
export const runImport = id => axios.post(`/imports/v1/${id}/run`, {});
export const exportEntity = data => axios.post(`/exports/v1`, data);
export const updateSchema = (id, schema) => axios.put(`/imports/v1/${id}/schema`).then(_ref => {
  let {
    data
  } = _ref;
  if (data.url) {
    return uploadToS3(data.url, new File([JSON.stringify(schema)], 'schema.json', {
      type: 'application/json'
    }));
  }
  throw new Error('No schema url provided');
});
export const sendMatching = id => axios.post(`/imports/v1/${id}/matching`);
export const getWarnings = id => {
  return axios.get(`/imports/v1/${id}/warnings`, {}).then(result => {
    if (result.data.json && result.data.json.url) return Axios.get(result.data.json.url).then(_ref2 => {
      let {
        data
      } = _ref2;
      return {
        warnings: data,
        excelUrl: result.data.excel.url
      };
    });
    throw new Error('No schema url provided');
  });
};
export const getErrors = id => {
  return axios.get(`/imports/v1/${id}/errors`, {}).then(result => {
    if (result.data.json && result.data.json.url) return Axios.get(result.data.json.url).then(_ref3 => {
      let {
        data
      } = _ref3;
      return {
        errors: data,
        excelUrl: result.data.excel.url
      };
    });
    throw new Error('No schema url provided');
  });
};
export const getFieldsSchema = entity => axios.get(`/imports/v1/schema/${entity}`);
export const getIdsToExport = function (entity, params) {
  if (params === void 0) {
    params = {};
  }
  return axios.get(`/imports/v1/search/${entity}`, {
    params: Object.keys(params).reduce((obj, key) => _objectSpread(_objectSpread({}, obj), Array.isArray(params[key]) ? {
      [`${key}[]`]: params[key]
    } : {
      [key]: params[key]
    }), {}),
    paramsSerializer: {
      serialize: p => qs.stringify(p, {
        arrayFormat: 'comma',
        encode: false
      })
    }
  });
};
export const getExportStatus = id => axios.get(`/imports/v1/export/${id}`);
export const getTableSchema = function (entity, type, lang) {
  if (type === void 0) {
    type = 'create';
  }
  return axios.get(`/imports/v1/tableSchema/${entity}?type=${type}&language=${lang}`);
};
export const getTotalRegisters = entity => axios.get(`/list/v1/${entity}/exist`);